import '@babel/polyfill';
import Vue, {ComponentOptions} from 'vue';
import './plugins/vuetify';
import './plugins/vue-authenticate';
import {i18n} from './plugins/i18n';
import App from './App.vue';
import router from './router.js';
import store from './store.js';
import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import PermissionChecker from './plugins/gate.js';
import User from './plugins/user.js';

Vue.prototype.$gate = new PermissionChecker();
Vue.prototype.$user = new User();

// references.d.ts
/**
 * Extends interfaces in Vue.js
 */
declare module 'vue/types/options' {
    interface ComponentOptions<V extends Vue> {
        router?: string | string[];
    }
}

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

